import { useEffect, useRef } from "react";
import * as echarts from "echarts";

export const CHART = {
  ink: "#18224b",
  muted: "#5b6384",
  accent: "#6b4ef6",
  orange: "#ff8a3d",
  pink: "#e7a0c4",
  green: "#178a5b",
};

export function OpsChart({
  option,
  height = 280,
}: {
  option: echarts.EChartsOption;
  height?: number;
}) {
  const ref = useRef<HTMLDivElement>(null);
  const chartRef = useRef<echarts.ECharts | null>(null);

  useEffect(() => {
    if (!ref.current) return;
    const chart = chartRef.current ?? echarts.init(ref.current);
    chartRef.current = chart;
    chart.setOption(option, true);
    const onResize = () => chart.resize();
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, [option]);

  useEffect(
    () => () => {
      chartRef.current?.dispose();
      chartRef.current = null;
    },
    [],
  );

  return <div className="ops-chart" ref={ref} style={{ height }} />;
}

export function pairs(counts: Record<string, number>, limit = 8) {
  return Object.entries(counts)
    .sort((a, b) => b[1] - a[1])
    .slice(0, limit);
}
